import { render, staticRenderFns } from "./OrgChartNode.vue?vue&type=template&id=622897a1&scoped=true&"
import script from "./OrgChartNode.vue?vue&type=script&lang=js&"
export * from "./OrgChartNode.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartNode.vue?vue&type=style&index=0&id=622897a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622897a1",
  null
  
)

export default component.exports